import { Box, keyframes, styled } from "@mui/material";

interface IVRPulseIndicatorProps {
  color?: string;
  offset?: number;
  size?: number;
}

const pulse = keyframes`
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(85, 204, 46, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 6px rgba(85, 204, 46, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(85, 204, 46, 0);
  }
`;

const IndicatorDot = styled(Box)({
  position: "absolute",
  zIndex: 1,
  top: 0,
  right: 0,
  borderRadius: "50%",
  animation: `${pulse} 2s infinite`,
  "@media (prefers-reduced-motion: reduce)": {
    animation: "none",
  },
});

const VRPulseIndicator = ({ color = "yellow", offset = 0, size = 12 }: IVRPulseIndicatorProps) => {
  return <IndicatorDot style={{ top: offset, right: offset }} sx={{ width: size, height: size, backgroundColor: color }} />;
};

export default VRPulseIndicator;
